import React, { useState } from 'react';
import { MenuItems } from './menu-items';
import useStyles from './sort.styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Paper from '@material-ui/core/Paper';

const Sort = (props) => {
    const classes = useStyles();
    const [click, setClick] = useState(false);
    const handleClick = () => setClick(!click);
    const [selected, setSelected] = useState();

    const handleSortBy = (colId, order) => {
        setClick(!click);
        let descending = order === 'desc' ? true : false;
        props.handleSortBy(colId, descending);
    }

    return (
        <>
        <div style={{marginLeft: '6px'}} className={classes.root}>
            <div className={
                click ? `${classes.title} ${classes.titleclicked}` : classes.title} 
                onClick={handleClick}>
                    Sort by <ArrowDropDownIcon/>
            </div>
            <div className={classes.paper}>
                <ul className={click ? `${classes.ddownmenu} ${classes.clicked}` : classes.ddownmenu} >
                    <Paper elevation={3} >
                        {MenuItems.map((item, index) => {
                            return (
                                <li key={index} onClick={() => setSelected(index)}>
                                    <div 
                                        className={index === selected ? `${classes.dropdownlink} ${classes.selected}` : classes.dropdownlink}
                                        onClick={() => handleSortBy(item.column, item.sort)}
                                    >
                                        {item.title}
                                    </div>
                                </li>
                            );
                        })}
                    </Paper>
                </ul>
            </div>
        </div>
      </>
    );
}

export default Sort;